import * as XLSX from "xlsx";

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/** ISO -> "20 Sep 2026, 08:46 AM" (local time); raw value if unparseable. */
function fmtTime(iso: any): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return String(iso);
  const h = d.getHours();
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    `${pad(d.getDate())} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ` +
    `${pad(h % 12 || 12)}:${pad(d.getMinutes())} ${h < 12 ? "AM" : "PM"}`
  );
}

/**
 * Downloads an alert's scan history (the API's duplicateScanDetails) as an
 * Excel sheet - one row per scan, every field the API sends. Shared by the
 * dashboard's alert drawer and the Recent Alerts report drawer.
 * Returns false when there is nothing to export.
 */
export function exportScanHistoryExcel(list: any[], seqNo?: any): boolean {
  const items = Array.isArray(list) ? list : [];
  if (!items.length) return false;

  const headers = [
    "Scan",
    "Sequence No",
    "Scan Time",
    "Status",
    "Remarks",
    "Name",
    "Mobile No",
    "Email",
    "City",
    "State",
    "Address",
  ];
  const rows = items.map((s: any, i: number) => [
    `Scan ${i + 1}`,
    s.qr || seqNo || "",
    fmtTime(s.time),
    s.status || "",
    s.remarks || "",
    s.name || "",
    s.mobile || "",
    s.email || "",
    s.city || "",
    s.state || "",
    s.address || "",
  ]);

  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  ws["!cols"] = [8, 14, 22, 10, 18, 18, 14, 24, 16, 16, 60].map((wch) => ({
    wch,
  }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Scan History");
  const code = String(seqNo || items[0].qr || "code").replace(/[^\w-]+/g, "_");
  XLSX.writeFile(
    wb,
    `scan-history-${code}-${new Date().toISOString().slice(0, 10)}.xlsx`,
  );
  return true;
}
